import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetGetListServiceProviderServices, IResponseGetGetListServiceProviderServices } from "./types"
import { GetGetListServiceProviderServicesUrl } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getGetListServiceProviderServices(
	{ ...rest }: IPropsGetGetListServiceProviderServices,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetGetListServiceProviderServices> =
			await apiPrivate.get(`${GetGetListServiceProviderServicesUrl}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetGetListServiceProviderServices(
	data: IPropsGetGetListServiceProviderServices,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetGetListServiceProviderServices,
					unknown,
					IResponseGetGetListServiceProviderServices
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETLISTSERVICEPROVIDER, ...Object.values(data)],
		queryFn: () => getGetListServiceProviderServices(data, apiPrivate),
		...options,
	})
}
